// Hack Ionic, yet again
export function setRadioTabIndexToNegativeOneWhenAble(listId: string, radioIdPrefix: string) {
    const listElem = document.getElementById(listId);

    // TabIndex should always be -1
    const observer = new MutationObserver((mutations) => {
      const radioItemMutationWithZeroTabIndex = mutations
        .find(mutation =>
          mutation.target instanceof HTMLElement &&
          mutation.target.tabIndex === 0 &&
          mutation.target.id.startsWith(radioIdPrefix)
        );
      if (radioItemMutationWithZeroTabIndex == null) return;
      if (radioItemMutationWithZeroTabIndex.target instanceof HTMLElement) {
        radioItemMutationWithZeroTabIndex.target.tabIndex = -1;
      }

      observer.disconnect();
    });
    observer.observe(listElem, { attributeFilter: ['tabindex'], subtree: true });
  }